import DataFetch from '../../Utility/data-fetch'
import {default as Storage} from '../../Utility/site-cookies'

const call = (strongsApiUrl) => {
    return {
        preSelectedClass: 'bg-yellow-300',
        highlightClass: 'bg-green-100',
        selectionClass: 'selected',

        controls: {},

        highlightMode: false,
        verseNumbers: true,
        redLetter: false,
        footnotes: true,
        crossReferences: false,
        strongs: false,
        markableVerses: [],
        highlightMarkedVerses: [],

        updateVersePreferences(interlinearMode) {
            this.verseNumbers = Storage().readPref('verse-numbers', 'true') === 'true'
            this.redLetter = Storage().readPref('red-letter') === 'true'
            this.footnotes = Storage().readPref('footnotes') === 'true'
            this.crossReferences = Storage().readPref('cross-references') === 'true'
            this.strongs = Storage().readPref('strongs') === 'true' || interlinearMode
        },
        updateHighlightMode(value) {
            this.highlightMode = value

            if (!this.highlightMode) {
                // Clear marked verses.
                for (let i = 0; i < this.markableVerses.length; i++) {
                    this.markableVerses[i].classList.remove(this.selectionClass)
                    this.markableVerses[i].classList.remove(this.highlightClass)
                }

                this.controls.classList.add('hidden')
            }
        },
        initHighlighting(userSignedIn) {
            if (!userSignedIn) return;

            this.controls = document.querySelector('#bible-sidebar-controls')
            this.markableVerses = document.getElementsByClassName('bible-selectable-verse')

            for (let i = 0; i < this.markableVerses.length; i++) {
                this.markableVerses[i].addEventListener('click', () => {
                    if (!this.highlightMode || this.markableVerses[i].classList.contains(this.preSelectedClass)) {
                        return
                    }

                    if (this.markableVerses[i].classList.contains(this.selectionClass)) {
                        this.markableVerses[i].classList.remove(this.selectionClass)
                        this.markableVerses[i].classList.remove(this.highlightClass)
                    } else {
                        this.markableVerses[i].classList.add(this.selectionClass)
                        this.markableVerses[i].classList.add(this.highlightClass)
                    }

                    this.highlightMarkedVerses = document.getElementsByClassName(this.selectionClass)

                    if (this.highlightMarkedVerses.length > 0) {
                        this.controls.classList.remove('hidden')
                    } else {
                        this.controls.classList.add('hidden')
                    }
                })
            }
        },
        async getReferenceLibrary(translationCode, testamentCode, strongsNumber) {
            // If strongs are not visible, ignore clicks.
            if (!this.strongs || this.highlightMode) {
                return
            }

            // Switch to the correct translations.
            switch (translationCode.toLowerCase()) {
                case 'kjva':
                case 'kjv':
                    translationCode = 'KJV'
                    break
                default:
                    translationCode = 'NAS'
                    break
            }

            // Switch to language for the bible testament provided.
            let lexiconLanguage = 'G'

            switch (testamentCode) {
                case 'N':
                    lexiconLanguage = 'G'
                    break
                case 'O':
                    lexiconLanguage = 'H'
                    break
                default:
                    lexiconLanguage = 'X'
            }

            const properStrongsNumber = parseInt(strongsNumber, 10)

            await DataFetch.get(strongsApiUrl + `?strongsNumber=${translationCode}-${lexiconLanguage}${properStrongsNumber}`)
                .then(response => {
                    window.open(response.data.url, '_blank')
                })
                .catch(err => {
                    console.log(err)
                })
        },
    }
}

export default call